export const parseIdDash = (id: TIdDashSlug | `${number}`): [number, string] => {
  const matches = id.match(/^(\d+)(?:-(.+))?$/)
  const [, num, str] = matches || []
  return [+num, str || '-']
}
